module.exports = __webpack_public_path__ + "static/robert-keller-ae01b8b0b8f93a819faf877a45078f66.png";